export default __webpack_public_path__ + "static/media/declaracionjuradamemoria2023.3cdf37ae.pdf";